function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { createUnsupportedError } from "./utils/unsupportedError.js";
/**
 * @summary SDK
 * @memberOf SDK
 * @description Defines an action that's a string literal, no validations or manipulations are performed
 */

var RawAction = /*#__PURE__*/function () {
  function RawAction(raw) {
    _classCallCheck(this, RawAction);

    this.raw = raw;
  }

  _createClass(RawAction, [{
    key: "toString",
    value: function toString() {
      return this.raw;
    }
  }, {
    key: "toJson",
    value: function toJson() {
      return {
        error: createUnsupportedError("unsupported action ".concat(this.constructor.name))
      };
    }
  }]);

  return RawAction;
}();

export { RawAction };